import { useTheme } from "@mui/material";
import ActionIconBase, { GlyphBox } from "./ActionIconBase";
import { IconProps } from "./icon.interface";

/**
 * Get Link — the chain-link glyph (`LinkOutlined`).
 *
 * `quaternary.dark` because a link is blue by convention, and because the Users
 * row already spends four colours: Edit (secondary), Login As (black), Send
 * Email (grey), Delete (red). A fifth action needs a fifth colour or the row
 * stops being readable at a glance.
 */
const GLYPH =
  "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z";

/** `GLYPH`s own ink box — see `GlyphBox` in ActionIconBase. */
const GLYPH_BOX: GlyphBox = [2, 7, 20, 10];

export default function LinkIcon(props: IconProps) {
  const theme = useTheme();
  return (
    <ActionIconBase
      {...props}
      color={theme.palette.quaternary.dark}
      glyph={GLYPH}
      glyphBox={GLYPH_BOX}
    />
  );
}
